// extracted by mini-css-extract-plugin
module.exports = {"button":"Second_button__Q-RYh","errorMsg":"Second_errorMsg__PPio6"};